import { haFunzionalita } from "@/utils/plans.js";

export function puoModificareAnagraficaBilancio(
  user,
  anagraficaGiaSalvata = false
) {
  return !anagraficaGiaSalvata || haFunzionalita(user, "modifica_anagrafica");
}
